module.exports = __webpack_public_path__ + "static/media/logo.f321b864.png";